import { useState } from "react";
import { Mail, RefreshCw } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "@/hooks/use-toast";

const AccountPendingOverlay = () => {
  const { profile } = useAuth();
  const [resending, setResending] = useState(false);

  const handleResend = async () => {
    if (!profile || resending) return;
    setResending(true);
    try {
      const isCompawdre = profile.user_type === "compawdre";
      const fnName = isCompawdre ? "send-compawdre-welcome-email" : "send-welcome-email";
      const fnUrl = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/${fnName}`;
      
      await fetch(fnUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "apikey": import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
        },
        body: JSON.stringify({ name: profile.full_name, email: profile.email }),
      });

      toast({
        title: "Correo reenviado",
        description: "Revisa tu bandeja de entrada y carpeta de spam.",
      });
    } catch {
      toast({
        title: "Error",
        description: "No se pudo reenviar el correo. Intenta de nuevo.",
        variant: "destructive",
      });
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 backdrop-blur-sm px-4">
      <div className="bg-card rounded-3xl shadow-hover max-w-md w-full p-8 text-center animate-fade-in">
        <div className="mx-auto w-20 h-20 rounded-full flex items-center justify-center mb-6" style={{ backgroundColor: "rgba(64,137,200,0.1)" }}>
          <Mail className="w-10 h-10" style={{ color: "#3273a4" }} />
        </div>
        
        <h2 className="font-fredoka text-2xl text-foreground mb-3">
          Activa tu cuenta
        </h2>
        
        <p className="font-poppins text-muted-foreground mb-2 leading-relaxed">
          Tu cuenta aún no ha sido activada. Revisa tu correo electrónico y haz clic en el <strong>botón de activación</strong> que te enviamos.
        </p>
        
        <p className="font-poppins text-sm text-muted-foreground mb-6">
          Enviamos el correo a: <span className="font-semibold text-foreground">{profile?.email}</span>
        </p>

        <button
          onClick={handleResend}
          disabled={resending}
          className="inline-flex items-center gap-2 font-poppins text-sm px-6 py-3 rounded-xl transition-colors disabled:opacity-50"
          style={{ backgroundColor: "#3273a4", color: "#ffffff" }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#ebd353";
            e.currentTarget.style.color = "#252a2a";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#3273a4";
            e.currentTarget.style.color = "#ffffff";
          }}
        >
          <RefreshCw className={`w-4 h-4 ${resending ? "animate-spin" : ""}`} />
          {resending ? "Reenviando..." : "Reenviar correo de activación"}
        </button>
        
        <p className="font-poppins text-xs text-muted-foreground mt-4">
          También revisa tu carpeta de spam o correo no deseado.
        </p>
      </div>
    </div>
  );
};

export default AccountPendingOverlay;
